import React, { useEffect, useState } from "react";
import "./assets/css/TemplateDesign.css";
import ResizableNonEditableAccupix from "./ResizableNonEditableAccupix";

let default_style = {
  width: "100%",
  height: "100%",
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  padding: "0",
  margin: "0",
  border: "none",
};

const NonEditableAccupixComponent = (props) => {
  const [top, setTop] = useState(props.top);
  const [left, setLeft] = useState(props.left);
  const [width, setWidth] = useState(props.width);
  const [height, setHeight] = useState(props.height);
  const [rotateAngle] = useState(props.rotateAngle);
  const [backgroundColor, setBackgroundColor] = useState(props.backgroundColor);
  const [roundedCorner, setRoundedCorner] = useState(props.rounded_corner);
  const [margin_top, setMarginTop] = useState(props.margin_top);
  const [margin_left, setMarginLeft] = useState(props.margin_left);
  const [padding_top, setPaddingTop] = useState(props.padding_top);
  const [padding_right, setPaddingRight] = useState(props.padding_right);
  const [padding_bottom, setPaddingBottom] = useState(props.padding_bottom);
  const [padding_left, setPaddingLeft] = useState(props.padding_left);
  const [aspect_ratio_width, setAspectRatioWidth] = useState(
    props.aspect_ratio_width
  );
  const [aspect_ratio_height, setAspectRatioHeight] = useState(
    props.aspect_ratio_height
  );
  const [aspectRatioFlag, setAspectRatioFlag] = useState(props.aspectRatioFlag);
  const [z_index, setZIndex] = useState(props.z_index);
  const [accupix_satellite_lock, setAccupixSatelliteLock] = useState(props.accupix_satellite_lock);

  useEffect(() => {
    setBackgroundColor(props.backgroundColor);
    setRoundedCorner(props.rounded_corner);
    setMarginTop(props.margin_top);
    setMarginLeft(props.margin_left);
    setPaddingTop(props.padding_top);
    setPaddingRight(props.padding_right);
    setPaddingBottom(props.padding_bottom);
    setPaddingLeft(props.padding_left);
    setTop(props.top);
    setLeft(props.left);
    setWidth(props.width);
    setHeight(props.height);
    setAspectRatioWidth(props.aspect_ratio_width);
    setAspectRatioHeight(props.aspect_ratio_height);
    setAspectRatioFlag(props.aspectRatioFlag);
    setZIndex(props.z_index);
    setAccupixSatelliteLock(props.accupix_satellite_lock);
  }, [
    props.backgroundColor,
    props.rounded_corner,
    props.margin_top,
    props.margin_left,
    props.padding_top,
    props.padding_right,
    props.padding_bottom,
    props.padding_left,
    props.top,
    props.left,
    props.width,
    props.height,
    props.aspect_ratio_width,
    props.aspect_ratio_height,
    props.aspectRatioFlag,
    props.z_index,
    props.accupix_satellite_lock,
  ]);

  function setNonEditableAccupixDesign(
    htmldata,
    id,
    left,
    top,
    width,
    height,
    rotateAngle,
    backgroundColor,
    roundedCorner,
    resize = false,
    margin_top,
    margin_left,
    padding_top,
    padding_right,
    padding_bottom,
    padding_left,
    aspect_ratio_width,
    aspect_ratio_height,
    z_index
  ) {
    props.parentSetNonEditableAccupixDesign(
      htmldata,
      id,
      left,
      top,
      width,
      height,
      props.title,
      rotateAngle,
      backgroundColor,
      roundedCorner,
      resize,
      margin_top,
      margin_left,
      padding_top,
      padding_right,
      padding_bottom,
      padding_left,
      aspect_ratio_width,
      aspect_ratio_height,
      z_index
    );
  }

  return (
    <ResizableNonEditableAccupix
      top={top}
      left={left}
      width={width}
      height={height}
      rotateAngle={rotateAngle}
      backgroundColor={backgroundColor}
      roundedCorner={roundedCorner}
      margin_top={margin_top}
      margin_left={margin_left}
      padding_top={padding_top}
      padding_right={padding_right}
      padding_bottom={padding_bottom}
      padding_left={padding_left}
      aspect_ratio_width={aspect_ratio_width}
      aspect_ratio_height={aspect_ratio_height}
      aspectRatioFlag={aspectRatioFlag}
      z_index={z_index}
      accupix_satellite_lock={accupix_satellite_lock}
      parentSetNonEditableAccupixDesign={setNonEditableAccupixDesign}
      id={props.id}
      title={props.title}
    >
      <div style={default_style}>
        <img
          alt="accupix.png"
          className="accupix_class"
          title="accupix"
          src={
            process.env.REACT_APP_ACCUPIX_URL_PHOTOPATH +
            "media/static/accupix.png"
          }
          style={default_style}
        ></img>
      </div>
    </ResizableNonEditableAccupix>
  );
};

export default NonEditableAccupixComponent;
